<section>
  <form
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit()"
    class="mx-auto w-full md:w-2/3 lg:w-1/2"
  >
    <div class="tui-form__row flex flex-col gap-4 md:flex-row">
      <div class="flex-1">
        <tui-textfield>
          <label tuiLabel>First name <span class="tui-required"></span></label>
          <input [formControl]="formGroup.controls.firstName" tuiTextfield />
        </tui-textfield>
        <tui-error
          formControlName="firstName"
          [error]="[] | tuiFieldError | async"
        />
      </div>
      <div class="flex-1">
        <tui-textfield>
          <label tuiLabel>Last name <span class="tui-required"></span></label>
          <input [formControl]="formGroup.controls.lastName" tuiTextfield />
        </tui-textfield>
        <tui-error
          formControlName="lastName"
          [error]="[] | tuiFieldError | async"
        />
      </div>
    </div>
    <div class="tui-form__row">
      <tui-textfield>
        <label tuiLabel>Company</label>
        <input [formControl]="formGroup.controls.company" tuiTextfield />
      </tui-textfield>
      <tui-error
        formControlName="company"
        [error]="[] | tuiFieldError | async"
      />
    </div>
    <div class="tui-form__row">
      <tui-textfield>
        <label tuiLabel>Email <span class="tui-required"></span></label>
        <input [formControl]="formGroup.controls.email" tuiTextfield />
      </tui-textfield>
      <tui-error formControlName="email" [error]="[] | tuiFieldError | async" />
    </div>
    <div class="tui-form__row text-left">
      <tui-textfield>
        <label tuiLabel>Message <span class="tui-required"></span></label>
        <textarea
          [formControl]="formGroup.controls.message"
          tuiTextarea
          [max]="6"
          [min]="6"
        ></textarea>
      </tui-textfield>
      <tui-error
        formControlName="message"
        [error]="[] | tuiFieldError | async"
      ></tui-error>
    </div>
    <div class="tui-form__row">
      <label tuiLabel class="flex items-center gap-2">
        <input
          formControlName="terms"
          tuiCheckbox
          type="checkbox"
          [size]="'m'"
        />
        <span class="tui-text_body-m">
          I've read and accept the
          <a
            href="https://capawesome.io/privacy/"
            target="_blank"
            class="text-[color:var(--tui-text-action)]"
            >Privacy Policy</a
          >. <span class="tui-required"></span>
        </span>
      </label>
      <tui-error
        formControlName="terms"
        [error]="[] | tuiFieldError | async"
      ></tui-error>
    </div>
    <div class="tui-form__row">
      <button
        tuiButton
        type="submit"
        [loading]="submitContactForm.isPending()"
        class="w-full"
      >
        Submit
      </button>
    </div>
  </form>
</section>
